import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScdPickerExtendedComponent } from './scd-picker-extended.component';
import { InputModule } from '../input/input.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { ButtonModule } from '../button/button.module';
import { DialogModule } from '../dialog/dialog.module';
import { ScdPickerDialogComponent } from './scd-picker-dialog.component';
import { AutocompleteModule } from '../autocomplete/autocomplete.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
    declarations: [ScdPickerExtendedComponent, ScdPickerDialogComponent],
    imports: [
        CommonModule,
        InputModule,
        CheckboxModule,
        ButtonModule,
        DialogModule,
        AutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        TooltipModule
    ],
    exports: [ScdPickerExtendedComponent, ScdPickerDialogComponent]
})
export class ScdPickerExtendedModule {}
